import PaymentTypesComponent from "../../../../components/partner/Settings/payment-types/payment-types";

export default function PaymentTypes() {
  return <PaymentTypesComponent />;
}
